module.exports = __webpack_public_path__ + "static/img/login3.338e4aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login3.jpg
// module id = 7Lh0
// module chunks = 1